import {DomainStore} from 'shared/store';
import {endpoints, types} from 'main/tools';
import Employee from 'main/stores/employees/Employee';

class ManagerDataSource {
  store = new DomainStore();

  async load() {
    await this.store._compose([
      endpoints.EMPLOYEES.MANAGERS
    ]);

    return this.store.getAllOrdered(types.EMPLOYEE, Employee);
  }
}

export default ManagerDataSource;
